import { render, staticRenderFns } from "./ossData.vue?vue&type=template&id=e45c7d88"
import script from "./ossData.vue?vue&type=script&lang=js"
export * from "./ossData.vue?vue&type=script&lang=js"
import style0 from "./ossData.vue?vue&type=style&index=0&id=e45c7d88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports